<div
  class="portal-detail-drawer"
  [class.portal-detail-drawer--shell]="drawerTitle"
  [class.portal-detail-drawer--topbar-hidden]="hideTopbar"
  [ngClass]="'portal-detail-drawer--' + variant">
  <div
    class="portal-detail-drawer__topbar"
    [class.portal-detail-drawer__topbar--hidden]="hideTopbar"
    *ngIf="drawerTitle">
    <div class="portal-detail-drawer__topbar-left">
      <button type="button" class="portal-detail-drawer__round-btn" (click)="backClick.emit()">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <span>{{ drawerTitle }}</span>
    </div>
    <button type="button" class="portal-detail-drawer__round-btn" (click)="closeClick.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div
    #drawerContent
    class="portal-detail-drawer__content"
    [class.portal-detail-drawer__card]="drawerTitle"
    [ngClass]="drawerTitle ? cardClass : ''">
    <ng-content></ng-content>
  </div>
</div>
